import { Image, Menu, Modal, Skeleton } from "antd";
import { Children, useContext, useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

import Cms from "../../assets/images/side_nav/cms.svg";
import Coust from "../../assets/images/side_nav/customer.svg";
import Dash from "../../assets/images/side_nav/dash.svg";
import Log from "../../assets/images/side_nav/log.svg";
import CategoryIcon from "../../assets/images/side_nav/cath.svg";
import SubCategoryIcon from "../../assets/images/side_nav/sub.svg";
import OccasionIcon from "../../assets/images/side_nav/star.svg";
import FeedIcon from "../../assets/images/side_nav/blog.svg";
import LeadershipIcon from "../../assets/images/side_nav/user.svg";
import BannerIcon from "../../assets/images/side_nav/notification.svg";
import EmailTemplateIcon from "../../assets/images/side_nav/file.svg";
import EmailLogsIcon from "../../assets/images/side_nav/log.svg";
import FaqIcon from "../../assets/images/side_nav/chat.svg";
import MasterIcon from "../../assets/images/side_nav/bi_collection.svg";
import SettingIcon from "../../assets/images/side_nav/file.svg";
import SocialIcon from "../../assets/images/side_nav/chat.svg";
import SeoIcon from "../../assets/images/side_nav/blog.svg";
import EnquiryIcon from "../../assets/images/side_nav/chat.svg";
import Logo from "../../assets/images/brand/black_white_logo.svg";
import { AuthContext } from "../../context/AuthContext";
import lang from "../../helper/langHelper";
import DeleteModal from "../DeleteModal";
import { useAppContext } from "../../context/AppContext";
import moment, { isMoment } from "moment";
import { Severty, ShowToast } from "../../helper/toast";
import { SettingOutlined, UserOutlined, LockOutlined } from "@ant-design/icons";
import { ZexoraLogo } from "../svgIcons";

export const countryWithAreas = [
  "646b2e0f46865f1f65565346", //Palestine
];

export const masterSubMenu = {
  web_page_heading: "Web Pages Heading",
  user_safety_toolkit: "User Safety Toolkit",
  user_privacy_tools: "User Privacy Tools",
  user_account_security: "User Account Security",
  work_at: "Working at Black Diary",
};

export const menuItems = [
  {
    key: "dashboard-management",
    path: "/dashboard",
    icon: Dash,
    label: lang("Dashboard"),
    isShow: true,
  },
  {
    key: "customer-manager",
    path: "/customer",
    label: `${lang("Customer")} ${lang("Management")}`,
    icon: Coust, //
  },
  {
    key: "category-manager",
    path: "/category",
    label: `${lang("Category")} ${lang("Management")}`,
    icon: CategoryIcon,
  },
  {
    key: "vendor-management",
    path: "/vendors",
    label: "Vendor Management",
    icon: MasterIcon,
  },
  {
    key: "sub-category-manager",
    path: "/sub-category",
    label: `${lang("Sub Category")} ${lang("Management")}`,
    icon: SubCategoryIcon,
  },
  {
    key: "keyword-emotion-management",
    path: "/keyword-emotion",
    label: `${lang("Keyword / Emotions")} ${lang("Management")}`,
    icon: FaqIcon,
  },
  {
    key: "inventory-management",
    icon: SettingIcon,
    label: "Inventory Management",
    children: [
      {
        key: "/inventory/products",
        path: "/inventory/products",
        icon: SocialIcon,
        label: "Products",
      },
      {
        key: "/inventory/digital-documents",
        path: "/inventory/digital-documents",
        icon: EmailTemplateIcon,
        label: "Digital Documents",
      },
      {
        key: "/inventory/variants",
        path: "/inventory/variants",
        icon: SettingIcon,
        label: "Variants",
      },
      {
        key: "/inventory/stock-tracking",
        path: "/inventory/stock-tracking",
        icon: SettingIcon,
        label: "Stocks Tracking",
      },
    ],
  },
  {
    key: "cart-management",
    path: "/cart",
    label: "Cart Management",
    icon: SettingIcon,
  },
  {
    key: "order-management",
    path: "/orders",
    label: "Orders",
    icon: SettingIcon,
  },
  {
    key: "occasion-manager",
    path: "/occasion",
    label: `${lang("Occasion")} ${lang("Management")}`,
    icon: OccasionIcon,
  },
  {
    key: "diary-manager",
    path: "/diary",
    label: `${lang("Feed")} ${lang("Management")}`,
    icon: FeedIcon,
  },
  {
    key: "leadership-management",
    path: "/leadership",
    icon: LeadershipIcon,
    label: `${lang("Leadership")} ${lang("Management")}`,
  },
  {
    key: "enquiry-management",
    path: "/enquiry",
    icon: EnquiryIcon,
    label: "Enquiry Management",
  },
  {
    key: "newsletter-management",
    path: "/newsletter",
    icon: EmailTemplateIcon,
    label: "Newsletter Management",
  },
  {
    key: "cms-management",
    path: "/cms",
    icon: Cms,
    label: `${lang("CMS")} ${lang("Management")}`,
  },
  {
    key: "email-template-manager",
    path: "/email-template",
    icon: EmailTemplateIcon,
    label: `${lang("Email Template")} ${lang("Management")}`,
  },
  {
    key: "email-log-management",
    path: "/email-logs",
    icon: EmailLogsIcon,
    label: `${lang("Email Logs")} ${lang("Management")}`,
  },
  {
    key: "banner-management",
    path: "/banner",
    icon: BannerIcon,
    label: `${lang("Banner")} ${lang("Management")}`,
  },
  {
    key: "faq-management",
    path: "/faq",
    icon: FaqIcon,
    label: `${lang("FAQ")} ${lang("Management")}`,
  },
  {
    key: "master-management",
    icon: MasterIcon,
    label: `${lang("Master")} ${lang("Management")}`,
    children: Object.entries(masterSubMenu).map(([key, value]) => ({
      key: `/master/${key}`,
      path: `/master/${key}`,
      icon: MasterIcon,
      label: value,
    })),
  },
  {
    key: "setting-management",
    icon: SettingIcon,
    label: "Setting Management",
    children: [
      {
        key: "/setting/social",
        path: "/setting/social",
        icon: SocialIcon,
        label: "Social Media",
      },
      {
        key: "/setting/general",
        path: "/setting/general",
        icon: SettingIcon,
        label: "General",
      },
      {
        key: "/setting/order",
        path: "/setting/order",
        icon: SettingIcon,
        label: "Order & Shipping",
      },
      {
        key: "/seo",
        path: "/seo",
        icon: SeoIcon,
        label: "SEO",
      },
    ],
  },
];

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const { userProfile, logout, setUserProfile } = useContext(AuthContext);
  const { country } = useAppContext();

  const [collapsed, setCollapsed] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [menuLinks, setMenuLinks] = useState([]);
  const [menuMode, setMenuMode] = useState("vertical");
  const [currentDateTime, setCurrentDateTime] = useState(moment());

  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  const showDeleteConfirm = (record) => {
    setIsLogoutModalVisible(true);
    // logout();
  };

  const renderTitle = (item) => {
    return (
      <>
        <Image preview={false} src={item.icon} />
        <span className="label">{item.label}</span>
      </>
    );
  };

  useEffect(() => {
    setLoading(true);
    if (!userProfile) return;
    if (userProfile.type == "Admin") {
      const items = country && country?.country_id && countryWithAreas.includes(country?.country_id) ? [...menuItems] : menuItems;

      setMenuLinks(items);
      setLoading(false);
      return;
    }

    const items = country && country?.country_id && countryWithAreas.includes(country?.country_id) ? [...menuItems] : menuItems;

    const newArray = items.filter((item) => {
      if (item.isShow) {
        return true;
      } else {
        return userProfile?.permission?.includes(item.key);
      }
    });

    const links = newArray.filter((item) => {
      if (item?.children?.length) {
        return true;
      } else if (!item?.children) {
        return true;
      } else {
        return false;
      }
    });

    setMenuLinks(links);
    setLoading(false);
    setRefresh((x) => !x);
  }, [userProfile, country]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMenuMode("inline");
      } else {
        setMenuMode("vertical");
      }
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {loading ? (
        [1, 2, 3, 4, 5, 6].map((item) => <Skeleton active key={item} />)
      ) : (
        <>
          <div className="brand-logo">
            <NavLink to="/dashboard" className={`brand-logo-link`}>
              <ZexoraLogo />
            </NavLink>
          </div>
          <Menu inlineCollapsed={false} mode={menuMode} className="sideNavMain">
            {menuLinks.map((item) => {
              if (item.children) {
                return (
                  <>
                    <Menu.SubMenu
                      key={item.key}
                      title={
                        <>
                          <span className="icon">
                            <Image preview={false} src={item.icon} />
                          </span>
                          <span className="label">{item.label}</span>
                        </>
                      }
                    >
                      {item.children.map((child) => (
                        <Menu.Item key={child.key}>
                          <NavLink to={child.path}>{child.label}</NavLink>
                        </Menu.Item>
                      ))}
                    </Menu.SubMenu>
                  </>
                );
              }

              return (
                <Menu.Item key={item.key}>
                  <NavLink to={item.path}>{renderTitle(item)}</NavLink>
                </Menu.Item>
              );
            })}

            <Menu.Item onClick={showDeleteConfirm}>
              <NavLink to={"#"}>
                <>
                  <Image preview={false} src={Log} />
                  <span className="label">Logout</span>
                </>
              </NavLink>
            </Menu.Item>
          </Menu>
        </>
      )}
      {isLogoutModalVisible && (
        <DeleteModal
          title={"Logout"}
          subtitle={`Are you sure you want to Logout the Application?`}
          show={isLogoutModalVisible}
          hide={() => {
            setIsLogoutModalVisible(false);
          }}
          onOk={async () => {
            setIsLogoutModalVisible(false); // Close the modal
            try {
              await logout();
            } catch (error) {
              console.error("Logout error:", error);
              ShowToast("Logout failed", Severty.ERROR);
            }
          }}
        />
      )}
    </>
  );
}

export default Sidenav;
